
import React, { useEffect } from 'react';

const ContentProtection: React.FC = () => {
  useEffect(() => {
    // 1. Disable Right Click (Context Menu)
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    // 2. Disable Developer Tools Shortcuts & View Source
    const handleKeyDown = (e: KeyboardEvent) => {
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
      }

      const isCtrlOrMeta = e.ctrlKey || e.metaKey;

      if (isCtrlOrMeta) {
        // Ctrl+U (View Source) or Cmd+U
        if (e.key.toLowerCase() === 'u') {
          e.preventDefault();
        }
        
        // Ctrl+S (Save Page)
        if (e.key.toLowerCase() === 's') {
             e.preventDefault();
        }

        // Ctrl+Shift+I/J/C (DevTools)
        if (e.shiftKey) {
          const key = e.key.toLowerCase();
          if (key === 'i' || key === 'j' || key === 'c') {
            e.preventDefault();
          }
        }
      }

      // Mac specific Cmd+Option+I/J/C (Chrome/Safari dev tools)
      if (e.metaKey && e.altKey) {
        const key = e.key.toLowerCase();
        if (key === 'i' || key === 'j' || key === 'c') {
          e.preventDefault();
        }
      }
    };

    // 3. Prevent Copy/Cut
    const handleCopyCut = (e: ClipboardEvent) => {
        // Allow copy/cut only within input/textarea elements
        const target = e.target as HTMLElement;
        if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
            e.preventDefault();
        }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopyCut);
    document.addEventListener('cut', handleCopyCut);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopyCut);
      document.removeEventListener('cut', handleCopyCut);
    };
  }, []);

  return (
    <style>{`
      /* 4. Disable Text Selection globally */
      body {
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* IE/Edge */
        user-select: none; /* Chrome/Opera */
      }
      
      /* Re-enable selection for Forms so users can type */
      input, textarea {
        -webkit-user-select: text !important;
        -moz-user-select: text !important;
        -ms-user-select: text !important;
        user-select: text !important;
      }

      /* 5. Disable Image Dragging */
      img {
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
      }
    `}</style>
  );
};

export default ContentProtection;
